import React from "react";
import {Type} from 'react-bootstrap-table2-editor';

const customFieldsColumnGenerate = (customFields, columnShow, headerSortingStyle, articleEditionDatatable,t,authParam,poDetailsEditionHandler) => {

    const columns = [];

    customFields.map((value, index)=>{
        let readAccess = authParam.access.find(access=>access.action == 'article_'+value.name+'_@!'+'read')
        let writeAccess = authParam.access.find(access=>access.action == 'article_'+value.name+'_@!'+'write')
        let textAppend = (!writeAccess) ? '*' : ''
        //pour les vues qui fusionnent des custom fields "article" et "po_details" (même nom possible sur les 2 forms), chaque champ a une clé unique (value.key) et doit être édité via son propre endpoint
        let dataField = value.key || value.name
        let editionHandler = (value.form=='po_details' && poDetailsEditionHandler) ? poDetailsEditionHandler : articleEditionDatatable

        if(!readAccess){
            let dataInit = {
                dataField: dataField,
                text:  value.name+textAppend,
                hidden: (columnShow.includes(dataField)) ? false : true,
                sort: true,
                headerSortingStyle,
            }
            if(!writeAccess){
                if(value.free){
                    dataInit['validator'] = (newValue, row, column, done) => {
                        editionHandler(row,value.name,newValue,done,false,t,authParam)
                        return {
                            async: true
                        };
                    }
                }else{
                    let options = [{'value':t('emptyValue'),'label':t('emptyValue')}]
                    let ouroptions = {}
                    ouroptions[t('emptyValue')]=''

                    value.list.map(item=>{
                        options.push({'value':item,'label':item})
                        ouroptions[item]=item
                    })

                    dataInit['editor'] ={
                        type: Type.SELECT,
                        options: options,
                        ouroptions: ouroptions,
                    }
                    dataInit['validator'] = (newValue, row, column, done) => {
                        editionHandler(row,value.name,column.editor.ouroptions[newValue],done,false,t,authParam)
                        return {
                            async: true
                        };
                    }
                }
            }
            else dataInit['editable']=false
            columns.push(dataInit)
        }
    })

    return columns;
};

export default customFieldsColumnGenerate;